import React, { useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import { useTranslation } from 'react-i18next';

import MDBox from "../components/MDBox";

import esLocale from 'date-fns/locale/es';

import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DatePicker from '@mui/lab/DatePicker';
import TimePicker from '@mui/lab/TimePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';


import PickersDay, {
    PickersDayProps,
    pickersDayClasses
} from "@mui/lab/PickersDay";
import addDays from "date-fns/addDays";
import isSameDay from "date-fns/isSameDay";

export default function OthelloTimer({ ...props }) {

    const {
        labelliteral,
        label,
        tipo,
        fieldname,
        readonly,
        disabled,
        showformato,
        abrecalendario,
        visible,
        fullWidth,
        calendas
    } = props;

    const { t } = useTranslation();

    const [locale, setLocale] = React.useState('es');
    //const [value, setValue] = React.useState(props.currentvalue != null && props.currentvalue != "" ? new Date(props.currentvalue) : null);

    const [timervalue, settimervalue] = useState(props.currentvalue != null && props.currentvalue != "" ? new Date(props.currentvalue) : "");
    const [evento, setevento] = useState(false);
    //const [visiblecalendario, setvisiblecalendario] = useState(false);

    let deshabilitado = disabled != null && disabled;
    let sololectura = readonly != null && readonly;
    let visibility = visible == null || visible;



    const handleOnChange = (newValue) => {

        let time = "";
        let timeToString = "";

        try {
            settimervalue(newValue);
            setevento(true);
            //setvisiblecalendario(false);
        } catch (e) {
            settimervalue("");
            setevento(true);
            //setvisiblecalendario(false);
        }

        if (props.onChange != null)
            props.onChange(getDataFormateado(newValue));
    };

    const getDataFormateado = (dato) => {
        let timeRetorno = "";

        if (dato != null && dato != "") {
            try {
                if (tipo == "time")
                    timeRetorno = dato.toDateString() + " " + dato.toLocaleTimeString();
                else
                    timeRetorno = dato.toDateString();
            }
            catch
            {
                timeRetorno = dato;
            }
        }

        return timeRetorno;
    }

    const renderWeekPickerDay = (date: Date, selectedDates: Array<Date | null>, pickersDayProps: PickersDayProps<Date>) => {
        //Si hay calendas
        if (highlightedDays != null && highlightedDays.length > 0) {
            const matchedStyles = highlightedDays.reduce((a, v) => {
                return isSameDay(date, v.date) ? v.styles : a;
            }, {});

            return (
                <PickersDay
                    {...pickersDayProps}
                    sx={{
                        ...matchedStyles
                    }}
                />
            );
        }

        return "";
    };

    //Si el que ha provocado el cambio es el evento entonces el valor del input es el que viene del evento, pero sino, el valor sera el de por defecto    
    let timefinal = evento ? timervalue : (props.currentvalue != null && props.currentvalue != "" ? new Date(props.currentvalue) : null);

    //MOntamos el dato formateado
    let timeshow = getDataFormateado(timefinal);

    //CALENDAS PARA EL CALENDARIO
    let highlightedDays = [];
    let renderdayfinal = "";

    //Si hay calendas creo el array de opciones
    if (calendas != null && calendas.length > 0) {
        calendas.forEach(x => {

            highlightedDays.push({

                date: new Date(x.dia), //addDays(new Date(), 6),
                styles: {
                    color: x.colorrgb,
                    fontWeight: "bold",
                    fontSize: 18,
                    //backgroundColor: "purple",
                    //textDecoration: "underline"
                }
            })

            renderdayfinal = { renderDay: renderWeekPickerDay };
        });
    }

    return (<>
        <input id={fieldname} name={fieldname} value={timeshow} type="hidden" maxlength={-123456789} />
        {visibility ? <MDBox pt={0.65} pr={1} pl={1} pb={1}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={esLocale}>
                <div>
                    {tipo == "time" ?
                        <TimePicker
                            readOnly={sololectura}
                            disabled={deshabilitado}
                            label={t != null && labelliteral != null ? t(labelliteral) : label}
                            value={timefinal}
                            mask={'_:_'}
                            onChange={(newValue) => handleOnChange(newValue)}
                            renderInput={(props) => <TextField {...props} variant="standard" fullWidth={fullWidth != null ? fullWidth : false} />} />
                        :
                        <DatePicker
                            readOnly={sololectura}
                            disabled={deshabilitado}
                            label={t != null && labelliteral != null ? t(labelliteral) : label}
                            mask={'__/__/____'}
                            value={timefinal}
                            onChange={(newValue) => handleOnChange(newValue)}
                            renderInput={(params) => <TextField {...params} variant="standard" helperText={showformato ? "dd/mm/yyyy" : ""} fullWidth={fullWidth != null ? fullWidth : false} />}
                            disableOpenPicker={abrecalendario == 'Hidden' ? true : false}
                            {...renderdayfinal}
                        />}
                </div>
            </LocalizationProvider>
        </MDBox> : ""}</>

    );
}

OthelloTimer.propTypes = {
    currentvalue: PropTypes.object,
    fieldname: PropTypes.string,
    labelliteral: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.object,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    visible: PropTypes.bool,
    tipo: PropTypes.oneOf([
        "date",
        "datetime",
        "time",
    ]),
    abrecalendario: PropTypes.oneOf([
        "",//se abre al obtener el foco
        "No", //en nigun caso se abre,
        "Hidden", // Oculta el botón del calendario
        "Calendar",//hay un boton para abrir el calendario
    ]),
    showformato: PropTypes.bool,
    fullWidth: PropTypes.bool,
    calendas: PropTypes.object, //Array de fechas  //{ dia: 08/11/2022 , colorrgb : "#32a852"} en C# FiltroCalendaModel
};